import { canTeach } from 'js/api/auth';

export default {
    computed: {
        stealthMode: function() {
            return canTeach(this.$store.state.users.current)
        },
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/assignment/stealthMixin.js